import { Component, Vue } from 'vue-property-decorator';
import { Breadcrumbs } from '../list/types';

@Component
export default class BreadcrumbsMixin extends Vue {
  public breadcrumbs: Breadcrumbs = [
    {
      text: 'Главная',
      to: { path: '/' },
    },
    {
      text: 'Компетенции',
      to: { name: 'competences' },
    },
  ];
}



// WEBPACK FOOTER //
// ./src/pages/competences/mixins/breadcrumbs-mixin.ts